import React, { useState } from 'react';
import ContextMenu from './ContextMenu';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { twMerge } from 'tailwind-merge';

interface Props {
    quotedRepliesAction: () => void;
    threadAction: () => void;
    hasThreadMessages: boolean;
}

const MessageActionMenu: React.FC<Props> = ({
    quotedRepliesAction,
    threadAction,
    hasThreadMessages,
}) => {
    const { i18next } = useAppContext();
    const [displayTooltip, setDisplayTooltip] = useState(false);
    return (
        <div
            onMouseEnter={() => {
                setDisplayTooltip(true);
            }}
            onMouseLeave={() => {
                setDisplayTooltip(false);
            }}
        >
            <div
                // The bubble is the tooltip, not this wrapper. The wrapper also
                // holds the menu, so a role here reports the whole menu as a
                // tooltip. Hide the bubble while it stays transparent.
                role="tooltip"
                aria-hidden={!displayTooltip}
                className={twMerge(
                    'absolute end-0 top-1/2 z-50 mt-2 max-w-xs translate-y-1/2 rounded-sm bg-gray-800 px-1.5 py-0.5 text-xs/5 font-normal whitespace-nowrap text-white shadow-xs transition-opacity duration-300',
                    displayTooltip ? 'opacity-100' : 'opacity-0',
                )}
            >
                {i18next.t('message.input.actions')}
            </div>
            <ContextMenu
                triggerLabel={i18next.t('menu.more_options')}
                className="bg-transparent hover:!bg-gray-200 hover:!bg-none"
                placement="bottom-end"
                preventOverflow={true}
                icon={<Icon iconKey="more_vert" />}
                skipPortal={true}
            >
                <MenuItem
                    onClick={quotedRepliesAction}
                    className="flex gap-x-2 text-gray-800"
                >
                    <Icon
                        iconKey="reply"
                        className="text-gray-600 group-hover:text-gray-700"
                    />

                    {i18next.t('message.input.reply')}
                </MenuItem>

                <MenuItem
                    onClick={threadAction}
                    className="flex gap-x-2 text-gray-800"
                >
                    <Icon
                        iconKey={
                            hasThreadMessages ? 'viewThreads' : 'addThread'
                        }
                        className="text-gray-600 group-hover:text-gray-700"
                    />
                    {i18next.t('ThreadMessages.CreateThread.Tooltip')}
                </MenuItem>
            </ContextMenu>
        </div>
    );
};

export default MessageActionMenu;
